module.exports = __webpack_public_path__ + "media/images/logo-webshop-full-97ebb00438214492e832b0d81571d93e.svg";